import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import {
  APPLICATION_WIPE_DATA,
  AUTH_LOGOUT,
  INITIAL_STATE,
  USERS_MGMT_CREATE_USER,
  USERS_MGMT_DELETE_USER,
  USERS_MGMT_BULK_DELETE,
  USERS_MGMT_UPDATE_USER,
  USERS_MGMT_FETCH,
  USERS_MGMT_UPDATE_PERMISSIONS,
  USERS_MGMT_FETCH_STATS,
  USERS_MGMT_CREATE_USERS_IN_BULK,
  USERS_MGMT_UPDATE_USERS_IN_BULK,
  USERS_MGMT_ADD_RESOURCE_TO_USER,
  USERS_MGMT_REMOVE_RESOURCE_FROM_USER,
} from '../actions';

const initialState = {
  list: null,
  stats: null,
  lastUpdated: null,
};

const updateStats = (state, { stats }) =>
  update(state, {
    $merge: {
      stats,
      lastUpdated: Date.now(),
    },
  });

const updateUsers = (state, { users }) =>
  update(state, {
    $merge: {
      list: users,
      lastUpdated: Date.now(),
    },
  });

const updatePermissions = (state, { id, permissions }) => {
  const index = state.list.findIndex(u => u.id === id);

  if (index === -1) return state;

  return update(state, {
    list: {
      [index]: { $merge: { permissions } },
    },
  });
};

const createUser = (state, { user }) => {
  console.log('user in createUser reducer', user);
  const index = state.list.findIndex(u => u.id === user.id);

  if (index === -1) {
    return update(state, {
      list: { $push: [user] },
    });
  }
  return update(state, {
    list: {
      [index]: { $merge: user },
    },
  });
};

const createUsersInBulk = (state, { users }) => {
  const updatedList = [...state.list];

  users.forEach(user => {
    const index = updatedList.findIndex(u => u.id === user.id);

    if (index === -1) {
      updatedList.push(user);
    } else {
      updatedList[index] = { ...updatedList[index], ...user };
    }
  });
  return update(state, {
    list: { $set: updatedList },
  });
};

const updateUserData = (state, { id, user }) => {
  const index = state.list.findIndex(u => u.id === id);

  return update(state, {
    list: {
      [index]: { $merge: user },
    },
  });
};

export const addResourceToUser = (state, { userId, resource }) => {
  const index = state.list.findIndex(u => u.id === userId);

  if (index === -1) return state;

  return update(state, {
    list: {
      [index]: {
        professionalProfile: {
          resources: { $push: [resource] },
        },
      },
    },
  });
};

export const removeResourceFromUser = (state, { userId, resourceId }) => {
  const index = state.list.findIndex(u => u.id === userId);

  if (index === -1) return state;

  const resourceIndex = state.list[index].professionalProfile.resources.findIndex(
    r => r.id === resourceId,
  );

  return update(state, {
    list: {
      [index]: {
        professionalProfile: {
          resources: { $splice: [[resourceIndex, 1]] },
        },
      },
    },
  });
};

const updateUsersInBulk = (state, { users }) => {
  const usersIds = users.map(user => user.id);

  const updatedList = state.list.map(u => {
    if (usersIds.includes(u.id)) {
      return { ...u, ...users.find(user => user.id === u.id) };
    }
    return u;
  });

  return update(state, {
    list: { $merge: updatedList },
  });
};

const deleteUser = (state, { id }) => {
  const index = state.list.findIndex(u => u.id === id);
  return update(state, {
    list: {
      $splice: [[index, 1]],
    },
  });
};

const bulkDeleteUsers = (state, { userIds }) => {
  const updatedList = state.list.filter(u => !userIds.includes(u.id));
  return update(state, {
    list: { $set: updatedList },
  });
};

const setInitialState = (state, { usersManagement = initialState }) =>
  update(state, {
    $merge: {
      ...usersManagement,
    },
  });

const cleanData = () => {
  return initialState;
};

const actionsRepo = {
  [INITIAL_STATE]: setInitialState,
  [USERS_MGMT_FETCH_STATS]: updateStats,
  [USERS_MGMT_FETCH]: updateUsers,
  [USERS_MGMT_UPDATE_PERMISSIONS]: updatePermissions,
  [USERS_MGMT_CREATE_USER]: createUser,
  [USERS_MGMT_CREATE_USERS_IN_BULK]: createUsersInBulk,
  [USERS_MGMT_UPDATE_USER]: updateUserData,
  [USERS_MGMT_ADD_RESOURCE_TO_USER]: addResourceToUser,
  [USERS_MGMT_REMOVE_RESOURCE_FROM_USER]: removeResourceFromUser,
  [USERS_MGMT_UPDATE_USERS_IN_BULK]: updateUsersInBulk,
  [USERS_MGMT_DELETE_USER]: deleteUser,
  [USERS_MGMT_BULK_DELETE]: bulkDeleteUsers,
  [APPLICATION_WIPE_DATA]: cleanData,
  [AUTH_LOGOUT]: cleanData,
};

export default createReducer({ initialState, actionsRepo });
